import { useApolloClient } from '@apollo/client';
import { useEffect } from 'react';
import { useTrackUserPresence } from 'src/graphql/entities/user-presence/hooks/use-track-user-presence';
import useConversationViewsStore from 'src/store/conversation-views';
import { useIdleTracker } from 'src/utils/hooks/useIdleTracker';

export const AppSettings = () => {
  const apolloClient = useApolloClient();
  const { runGC } = useConversationViewsStore();
  const { isIdle } = useIdleTracker();
  useTrackUserPresence();

  useEffect(() => {
    // running garbage collection on idle to reduce memory leaks
    if (isIdle) {
      apolloClient.cache.gc();
      runGC();
      console.info('Successfully run garbage collection');
    }
  }, [isIdle, apolloClient, runGC]);

  return null;
};
